import React, { useEffect, useMemo, useState } from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableRow, TextField, Paper, Select, MenuItem,
} from "@material-ui/core";
import UseStyles from '../../Summary/UseStyles';
import moment from 'moment';
import { validateDate } from '../../../Constants/utils';

import { PickListDataAPI } from '../../../API/PickListDataAPI';

import GoogleAutoCompleteText from '../../../Principal/EditGuarantor/GoogleAddressSearch';
export default function PersonalGuarantor({ guarantor, usStates, handleChange, setGuarantorInfo }) {
    const classes = UseStyles();
    const relationshipChoices = ["Self", "Business Partner", "Individual", "Owner", "Sibling", "Child", "Spouse"];
    const salutationChoices = ["Mr.", "Ms.", "Mrs.", "Dr.", "Prof."];
    const maritalChocies = ["Single", "Married", "Divorced", "Widowed", "Unknown"];
    const guar = guarantor?.guarantor;
    const maxDate = useMemo(() => moment(new Date()).format('YYYY-MM-DD'), []);
    const minDate = useMemo(() => moment(new Date()).subtract(100, 'years').format('YYYY-MM-DD'), []);
    const [businessTitleList, setBusinessTitleList] = useState(null);

    useEffect(() => {
        (async () => {
            if (!businessTitleList) {
                const response = await PickListDataAPI.getPickList({ object: "Contact", field: "Business_Title__c" });
                setBusinessTitleList(response);
            }
        })();
    }, [businessTitleList]);


    const [googleAddress, setGoogleAddress] = useState("");

    const updateMapInfo = (mapInfo) => {
        if (mapInfo.city) {
            setGoogleAddress(mapInfo.location);
            setGuarantorInfo((pre) => ({
                ...pre,
                guarantor: {
                    ...pre.guarantor,
                    address: mapInfo.streetNumber + " " + mapInfo.street,
                    city: mapInfo.city || "",
                    county: mapInfo.country || "",
                    state: mapInfo.stateCode.label || "",
                    zip_code: mapInfo.zipCode || "",
                }
            }))

        }
    };

    return (
        <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
                <TableBody>
                    <TableRow className={classes.row_color1}>
                        <TableCell style={{ width: "19%" }} className={classes.cell_header_bold} align="right">
                            Relationship to Applicant
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <Select
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                variant="filled"
                                value={guarantor?.relationship_to_applicant ?? ""}
                                style={{
                                    width: "100%",
                                    marginTop: "3px",
                                    marginLeft: "3px",
                                }}
                                name="relationship_to_applicant"
                                id="relationship_to_applicant"
                                onChange={e => handleChange(e, false)}>
                                {relationshipChoices.map((item, index) => (
                                    <MenuItem key={index} value={item}>
                                        {item}
                                    </MenuItem>
                                ))}
                            </Select>
                        </TableCell>
                        <TableCell style={{ width: "15%" }} className={classes.cell_header_bold} align="right">
                            Salutation
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <Select
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                variant="filled"
                                value={guar?.salutation || ""}
                                style={{
                                    width: "100%",
                                    marginTop: "3px",
                                    marginLeft: "3px",
                                }}
                                name="salutation"
                                id="salutation"
                                onChange={e => handleChange(e, true)}>
                                {salutationChoices.map((item, index) => (
                                    <MenuItem key={index} value={item}>
                                        {item}
                                    </MenuItem>
                                ))}
                            </Select>
                        </TableCell>
                        <TableCell style={{ width: "15%" }} className={classes.cell_header_bold} align="right">
                            Suffix
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <TextField
                                placeholder="Enter Suffix"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                }}
                                value={guar?.suffix ?? ""}
                                name="suffix"
                                id="suffix"
                                onChange={e => handleChange(e, true)}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow className={classes.row_color2}>
                        <TableCell style={{ width: "19%" }} className={classes.cell_header_bold} align="right">
                            First Name *
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <TextField
                                placeholder="Enter first name"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                }}
                                value={guar?.first_name ?? ""}
                                name="first_name"
                                id="first_name"
                                onChange={e => handleChange(e, true)}
                            />
                        </TableCell>
                        <TableCell style={{ width: "15%" }} className={classes.cell_header_bold} align="right">
                            Middle Name
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <TextField
                                placeholder="Enter middle name"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                }}
                                value={guar?.middle_name ?? ""}
                                name="middle_name"
                                id="middle_name"
                                onChange={e => handleChange(e, true)}
                            />
                        </TableCell>
                        <TableCell style={{ width: "15%" }} className={classes.cell_header_bold} align="right">
                            Last Name *
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <TextField
                                placeholder="Enter last name"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                }}
                                value={guar?.last_name ?? ""}
                                name="last_name"
                                id="last_name"
                                onChange={e => handleChange(e, true)}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow className={classes.row_color1}>
                        <TableCell style={{ width: "19%" }} className={classes.cell_header_bold} align="right">
                            Percent of Ownership *
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <TextField
                                placeholder="Enter Percent of Ownership"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                    pattern: "[0-9]"
                                }}
                                value={guarantor?.percent_of_ownership?.toString() ?? ""}
                                name="percent_of_ownership"
                                id="percent_of_ownership"
                                onChange={handleChange}
                            />
                        </TableCell>
                        <TableCell style={{ width: "15%" }} className={classes.cell_header_bold} align="right">
                            SSN *
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <TextField
                                placeholder="Enter SSN"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                    pattern: "[0-9]"
                                }}
                                value={guar?.ssn ?? ""}
                                name="ssn"
                                id="ssn"
                                onChange={e => handleChange(e, true)}
                            />
                        </TableCell>
                        <TableCell style={{ width: "15%" }} className={classes.cell_header_bold} align="right">
                            Date of Birth
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <TextField
                                placeholder="Enter Date of Birth"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                    max: maxDate,
                                    min: minDate
                                }}
                                value={guar?.date_of_birth ?? ""}
                                style={{
                                    width: "100%",
                                }}
                                name="date_of_birth"
                                id="date_of_birth"
                                type="date"
                                onChange={e => handleChange(e, true)}
                                error={guar?.date_of_birth && !validateDate(guar?.date_of_birth)}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow className={classes.row_color2}>
                        <TableCell style={{ width: "19%" }} className={classes.cell_header_bold} align="right">
                            Business Title
                        </TableCell>
                        <TableCell style={{ width: "17%", }} align="left">
                            <TextField
                                select
                                placeholder="Enter Business Title"
                                variant="filled"
                                value={guar?.business_title ?? ""}
                                style={{
                                    width: "100%",
                                    marginTop: "3px",
                                    marginLeft: "3px",
                                    maxWidth: '140px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                }}
                                title={guar?.business_title ?? ""}
                                name="business_title"
                                id="business_title"
                                onChange={e => handleChange(e, true)}>
                                {businessTitleList?.map((item) => (
                                    <MenuItem key={item} value={item}>
                                        {item}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </TableCell>
                        <TableCell style={{ width: "15%" }} className={classes.cell_header_bold} align="right">
                            Marital Status
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <Select
                                variant="filled"
                                value={guar?.marital_status ?? ""}
                                style={{
                                    width: "100%",
                                    marginTop: "3px",
                                    marginLeft: "3px",
                                }}
                                name="marital_status"
                                id="marital_status"
                                onChange={e => handleChange(e, true)}>
                                {maritalChocies.map((item, index) => (
                                    <MenuItem key={index} value={item}>
                                        {item}
                                    </MenuItem>
                                ))}
                            </Select>
                        </TableCell>
                        <TableCell style={{ width: "15%" }} className={classes.cell_header_bold} align="right">
                            Email
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <TextField
                                placeholder="Enter email"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                }}
                                value={guar?.email ?? ""}
                                name="email"
                                id="email"
                                onChange={e => handleChange(e, true)}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow className={classes.row_color1}>
                        <TableCell style={{ width: "19%" }} className={classes.cell_header_bold} align="right">
                            Telephone *
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <TextField
                                placeholder="Enter Telephone #"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                }}
                                value={guar?.telephone ?? ""}
                                name="telephone"
                                id="telephone"
                                onChange={e => handleChange(e, true)}
                            />
                        </TableCell>
                        <TableCell style={{ width: "15%" }} className={classes.cell_header_bold} align="right">
                            Mobile
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <TextField
                                placeholder="Enter Mobile #"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                }}
                                value={guar?.mobile ?? ""}
                                name="mobile"
                                id="mobile"
                                onChange={e => handleChange(e, true)}
                            />
                        </TableCell>
                        <TableCell style={{ width: "15%" }} className={classes.cell_header_bold} align="right">
                            Fax
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <TextField
                                placeholder="Enter Fax #"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                }}
                                value={guar?.fax ?? ""}
                                name="fax"
                                id="fax"
                                onChange={e => handleChange(e, true)}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow className={classes.row_color2}>
                        <TableCell style={{ width: "19%" }} className={classes.cell_header_bold} align="right" >
                            Search Address
                        </TableCell>
                        <TableCell style={{ width: "17%" }} colSpan={5}>
                            <GoogleAutoCompleteText
                                id={"map-address-1"}
                                variant="outlined"
                                className="gps_address_input"
                                placeholder="Enter address"
                                value={googleAddress}
                                setGoogleAddress={setGoogleAddress}
                                onMapChanged={updateMapInfo}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow className={classes.row_color2}>
                        <TableCell style={{ width: "19%" }} className={classes.cell_header_bold} align="right" >
                            Street Address *
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left" >
                            <TextField
                                placeholder="Enter Address 1"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                }}
                                value={guar?.address ?? ""}
                                name="address"
                                id="address"
                                onChange={e => handleChange(e, true)}
                            />

                        </TableCell>
                        <TableCell style={{ width: "15%" }} className={classes.cell_header_bold} align="right">
                            Address 2
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <TextField
                                placeholder="Enter Address 2"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                }}
                                value={guar?.address_2 ?? ""}
                                name="address_2"
                                id="address_2"
                                onChange={e => handleChange(e, true)}
                            />
                        </TableCell>
                        <TableCell style={{ width: "15%" }} className={classes.cell_header_bold} align="right">
                            County
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <TextField
                                placeholder="Enter County"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                }}
                                value={guar?.county ?? ""}
                                name="county"
                                id="county"
                                onChange={e => handleChange(e, true)}
                            />
                        </TableCell>
                    </TableRow>
                    < TableRow className={classes.row_color1}>
                        <TableCell style={{ width: "19%" }} className={classes.cell_header_bold} align="right">
                            City *
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <TextField
                                placeholder="Enter City"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                }}
                                value={guar?.city ?? ""}
                                name="city"
                                id="city"
                                onChange={e => handleChange(e, true)}
                            />
                        </TableCell>
                        <TableCell style={{ width: "15%" }} className={classes.cell_header_bold} align="right">
                            State *
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <Select
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                variant="filled"
                                value={guar?.state ?? ""}
                                style={{
                                    width: "100%",
                                    marginTop: "3px",
                                    marginLeft: "3px",
                                }}
                                name="state"
                                id="state"
                                onChange={e => handleChange(e, true)}>
                                {usStates.map((item, index) => (
                                    <MenuItem key={index} value={item}>
                                        {item}
                                    </MenuItem>
                                ))}
                            </Select>
                        </TableCell>
                        <TableCell style={{ width: "15%" }} className={classes.cell_header_bold} align="right">
                            Zip *
                        </TableCell>
                        <TableCell style={{ width: "17%" }} align="left">
                            <TextField
                                placeholder="Enter Zip"
                                variant="filled"
                                inputProps={{
                                    className: classes.textBoxDesign,
                                }}
                                value={guar?.zip_code ?? ""}
                                name="zip_code"
                                id="zip_code"
                                onChange={e => handleChange(e, true)}
                            />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer >
    )
}
